var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened === true
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Choose which columns you see"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.SearchPhrase,
                              expression: "SearchPhrase",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "search", placeholder: "Search..." },
                          domProps: { value: _vm.SearchPhrase },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.SearchPhrase = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._m(0),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "mt-3",
                          staticStyle: {
                            "max-height": "500px",
                            height: "500px",
                            "overflow-y": "auto",
                          },
                        },
                        _vm._l(_vm.Sections, function (s) {
                          return _c(
                            "div",
                            { key: s.Name },
                            [
                              _c("h6", { staticClass: "mt-3 mb-1" }, [
                                _vm._v(_vm._s(s.Name)),
                              ]),
                              _vm._v(" "),
                              _vm._l(s.Fields, function (f) {
                                return _c("div", { key: f.Id }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.ToggleColumnCommand(f.Id)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-regular fa-lg",
                                        class: f.IsSelected
                                          ? "fa-square-check"
                                          : "fa-square",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { attrs: { title: f.Title } },
                                        [_vm._v(_vm._s(f.TitleEllipsis))]
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("h5", [
                        _vm._v(
                          "Selected columns (" +
                            _vm._s(_vm.SelectedFields.length) +
                            "):"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "max-height": "500px",
                            height: "500px",
                            "overflow-y": "auto",
                          },
                        },
                        _vm._l(_vm.SelectedFields, function (f) {
                          return _c(
                            "div",
                            {
                              key: f.Id,
                              staticClass: "p-2 bg-secondary m-2 text-white",
                            },
                            [
                              _c("span", { attrs: { title: f.Title } }, [
                                _vm._v(_vm._s(f.TitleEllipsis)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "p-0 border-0 text-white",
                                  staticStyle: {
                                    "background-color": "transparent",
                                    "font-size": "1.3rem",
                                    float: "right",
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.RemoveColumnCommand(f.Id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        ×\n                                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.confirm },
                    },
                    [_vm._v("Confirm")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }